module.exports = __webpack_public_path__ + "static/media/delete.428beb6d.svg";